if (!window.gcbCollectionControls) {
  window.gcbCollectionControls = true;
  document.addEventListener('change', (event) => {
    const form = event.target.closest('.gcb-filter-form');
    if (form && event.target.matches('select,input[type="radio"],input[type="checkbox"]')) form.requestSubmit();
    if (event.target.id === 'gcb-coin-collection' && event.target.value) window.location.assign(event.target.value);
  });
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.gcb-filter-form');
    if (!form) return;
    event.preventDefault();
    const url = new URL(form.action, window.location.origin);
    for (const [key, value] of new FormData(form)) if (String(value).trim()) url.searchParams.append(key, value);
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    url.hash = 'gcb-find';
    window.location.assign(url.href);
  });
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.gcb-coin-go')) return;
    const select = document.getElementById('gcb-coin-collection');
    if (select && select.value) window.location.assign(select.value);
    else if (select) select.focus();
  });
}